.controlEnvironmentEffectivenessContainer {
    display: flex;
    gap: 5px;
    align-items: center;
}
